import { defineMessage } from 'services/localization';

export const messages = {
    deleteRequestSuccess: defineMessage('the_request_has_been_deleted'),
    uploadErrorDuplicateName: defineMessage('please_reupload_the_fil_e_name_is_already_added'),
    uploadErrorRestrictedFileType: defineMessage('sorry_the_file_type_of__due_to_security_reasons'),
    uploadErrorTooBig: defineMessage('sorry_the_file_filename_ximum_size_of_maxsizemb'),
    uploadErrorVirusFound: defineMessage('sorry_the_file_filename_hat_it_contains_a_virus'),
    uploadErrorAttachmentMaxCountExceeded: defineMessage('sorry_you_cannot_attach_cuments_to_each_request'),
    uploadErrorGeneric: defineMessage('oops_something_went_wrong'),
    resubmitRequestSuccess: defineMessage('the_request_has_been_up_esubmitted_for_approval'),
    saveUpdatedRequestSuccess: defineMessage('the_request_has_been_updated'),
    saveDraftRequestSuccess: defineMessage('the_request_has_been_updated'),
    saveAndApproveRequestSuccess: defineMessage('the_request_has_been_approved'),
    saveAndSubmitRequestSuccess: defineMessage('the_request_is_submitted_for_approval'),
    checkYourMatchingAllocations: defineMessage('check_your_matching_allocations'),
    filenameContainsRestrictedWords: defineMessage('attachment_filename_fil_d_substring_restriction'),
    qbooksCustomerCreationSuccess: defineMessage('customer_created'),
    xeroContactCreationSuccess: defineMessage('the_contact_has_been_created'),
    qbooksVendorCreationSuccess: defineMessage('the_vendor_has_been_created'),
};
